import React from "react";
import { Check } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";
import SectionHeading from "../SectionHeading";
import Reveal from "../Reveal";

const Results = () => {
  const { lang } = useLanguage();
  const t = translations[lang].results;

  return (
    <section className="bg-slate-50 py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <SectionHeading tag={t.tag} title={t.title} desc={t.desc} />
            <ul className="mt-8 space-y-4">
              {t.points.map((p, i) => (
                <Reveal as="li" key={i} delay={i * 80} className="flex items-start gap-3">
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
                    <Check className="w-3.5 h-3.5 text-emerald-600" />
                  </span>
                  <span className="text-slate-700 leading-relaxed">{p}</span>
                </Reveal>
              ))}
            </ul>
          </div>

          <div className="grid grid-cols-2 gap-5">
            {t.kpis.map((k, i) => (
              <Reveal key={k.label} delay={i * 100}>
                <div className="rounded-2xl bg-navy-900 p-8 text-center h-full flex flex-col items-center justify-center hover:bg-navy-800 transition-colors">
                  <div className="font-display font-extrabold text-4xl lg:text-5xl text-amber-400">
                    {k.value}
                  </div>
                  <div className="mt-3 text-sm text-slate-300">{k.label}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Results;
